import { z } from "zod";
import { CorrelatedStatsRestrictionDbSchema } from "./db-schemas";
import { CompressedEventMarket } from "./types";

export type CorrelatedStatsRestriction = z.infer<typeof CorrelatedStatsRestrictionDbSchema>;

export type PickRestrictions = {
	// event_id -> set of excluded participant_ids
	excluded_participants_by_event: Map<string, Set<string>>;
	// event_id -> set of excluded stat_types
	excluded_stat_types_by_event: Map<string, Set<string>>;
};

export function getPickRestrictions(
	current_picks: CompressedEventMarket[],
	correlated_stats: CorrelatedStatsRestriction[],
): PickRestrictions {
	const excluded_participants_by_event = new Map<string, Set<string>>();
	const stat_types_by_event = new Map<string, Set<string>>();

	for (const pick of current_picks) {
		if (!excluded_participants_by_event.has(pick.event_id)) {
			excluded_participants_by_event.set(pick.event_id, new Set());
		}
		for (const participant_id of pick.participant_ids) {
			excluded_participants_by_event.get(pick.event_id)!.add(participant_id);
		}

		if (!stat_types_by_event.has(pick.event_id)) {
			stat_types_by_event.set(pick.event_id, new Set());
		}
		stat_types_by_event.get(pick.event_id)!.add(pick.stat_type);
	}

	const excluded_stat_types_by_event = new Map<string, Set<string>>();
	for (const [event_id, stat_types] of stat_types_by_event) {
		const excluded = excluded_stat_types_by_event.get(event_id) ?? new Set<string>();
		for (const restriction of correlated_stats) {
			if (stat_types.has(restriction.left_stat_type)) {
				excluded.add(restriction.right_stat_type);
			}
			if (stat_types.has(restriction.right_stat_type)) {
				excluded.add(restriction.left_stat_type);
			}
		}
		if (excluded.size > 0) {
			excluded_stat_types_by_event.set(event_id, excluded);
		}
	}

	return { excluded_participants_by_event, excluded_stat_types_by_event };
}
